<template>
  <icon :style="{ color: 'hotpink' }" class="roll-spin" >
    <template #component>
      <svg width="1em" height="1em" id="successIcon" data-name="successIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path fill="#faac1a" class="cls-1" d="M16,32C7.16,32,0,24.84,0,16S7.16,0,16,0s16,7.16,16,16-7.16,16-16,16Z"/>
        <path fill="#fff" class="cls-2" d="M23.78,17.87c-.54-.14-1.1.13-1.29.63-.71,1.83-2.17,3.29-4,3.99-1.86.72-3.89.61-5.72-.32-2.4-1.21-3.91-3.83-3.76-6.51.12-2.15,1.17-4.1,2.88-5.34,1.71-1.24,3.86-1.64,5.9-1.09,1.41.38,2.65,1.19,3.6,2.36l.06.08-1.51.96c-.07.04-.05.14.02.17l4.1,1.24c.14.04.29-.05.31-.2l.61-4.24c.01-.08-.07-.13-.14-.09l-1.54.98-.08-.1c-1.23-1.6-2.96-2.77-4.88-3.28-2.39-.64-4.88-.3-7.02.95-2.13,1.25-3.64,3.26-4.25,5.67-1.18,4.68,1.75,9.75,6.4,11.07.84.24,1.69.35,2.52.35,3.68,0,7.09-2.22,8.5-5.8.12-.3.1-.64-.04-.93-.14-.28-.39-.48-.69-.56Z"/>
      </svg>
    </template>
  </icon>
</template>

<script>
import Icon from '@ant-design/icons-vue';
export default {
  name: "processingIcon",
  components: {Icon},
};
</script>

<style scoped>
.roll-spin{
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>